import actions from "./actions";
import { call, put, takeLatest, fork } from "redux-saga/effects";
import { CREATE_TURN, EXCHANGE_CODE, SPIN, TOPUP } from "./constants";
import { exchangeCodeApi, spinApi, topupApi } from "api/game";
import { createTurnApi } from "api/game";

export function* createTurnSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(createTurnApi, payload);
    yield put(actions.CREATE_TURN.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.CREATE_TURN.failure(err));
  }
}
export function* exchangeCodeSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(exchangeCodeApi, payload);
    yield put(actions.EXCHANGE_CODE.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.EXCHANGE_CODE.failure(err));
  }
}

export function* spinSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(spinApi, payload);
    yield put(actions.SPIN.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.SPIN.failure(err));
  }
}

export function* topupSaga(obj) {
  const { payload, onSuccess, onError } = obj;
  try {
    const res = yield call(topupApi, payload);
    yield put(actions.TOPUP.success(res));
    if (typeof onSuccess === "function") {
      onSuccess(res?.data);
    }
  } catch (err) {
    if (typeof onError === "function") {
      onError(err);
    }
    yield put(actions.TOPUP.failure(err));
  }
}

function* watchCommon() {
  yield takeLatest(CREATE_TURN.request, createTurnSaga);
  yield takeLatest(EXCHANGE_CODE.request, exchangeCodeSaga);
  yield takeLatest(SPIN.request, spinSaga);
  yield takeLatest(TOPUP.request, topupSaga);
}

export default function* rootChild() {
  yield fork(watchCommon);
}
